interface UiConfigState {
    displayGamificationWeekly?: boolean;
    displayRecordingState?: boolean;
}

const uiConfigState: UiConfigState = {};

function getUiConfigState(): UiConfigState {
    return uiConfigState;
}

export function setUiDisplayConfig(displayGamificationWeekly: boolean, displayRecordingState: boolean): void {
    const state = getUiConfigState();
    state.displayGamificationWeekly = displayGamificationWeekly;
    state.displayRecordingState = displayRecordingState;
}

export function getDisplayGamificationWeekly(): boolean {
    const state = getUiConfigState();
    return typeof state.displayGamificationWeekly === 'undefined' ? true : state.displayGamificationWeekly;
}

export function getDisplayRecordingState(): boolean {
    return getUiConfigState().displayRecordingState === true;
}
